import { LibraryStatistics } from '../../types';

export const mockLibraryStats: LibraryStatistics = {
  totalExercises: 156,
  totalEquipment: 89,
  totalMuscleGroups: 24,
  totalAdaptations: 12,
  equipmentUtilization: 78,
  muscleGroupCoverage: 92,
  adaptationCoverage: 85,
};

export const mockExerciseTypeStats = [
  { title: 'Compound', value: 89, suffix: 'exercises' },
  { title: 'Isolation', value: 52, suffix: 'exercises' },
  { title: 'Cardio', value: 15, suffix: 'exercises' },
];

export const mockDifficultyDistribution = [
  { title: 'Beginner (1-3)', percent: 25, status: 'success' as const },
  { title: 'Intermediate (4-6)', percent: 45, status: 'normal' as const },
  { title: 'Advanced (7-8)', percent: 25, status: 'active' as const },
  { title: 'Expert (9-10)', percent: 5, status: 'exception' as const },
];

export const mockEquipmentCategoryStats = [
  { title: 'Strength', value: 45, suffix: 'items' },
  { title: 'Cardio', value: 28, suffix: 'items' },
  { title: 'Functional', value: 16, suffix: 'items' },
];

export const mockEquipmentStatusDistribution = [
  { title: 'Available', percent: 82, status: 'success' as const },
  { title: 'In Use', percent: 15, status: 'normal' as const },
  { title: 'Maintenance', percent: 2, status: 'active' as const },
  { title: 'Out of Order', percent: 1, status: 'exception' as const },
];

export const mockMuscleGroupData = [
  { muscle: 'Quadriceps', exercises: 45, coverage: 95 },
  { muscle: 'Chest', exercises: 38, coverage: 92 },
  { muscle: 'Back', exercises: 42, coverage: 90 },
  { muscle: 'Shoulders', exercises: 35, coverage: 88 },
  { muscle: 'Hamstrings', exercises: 28, coverage: 85 },
  { muscle: 'Triceps', exercises: 25, coverage: 82 },
  { muscle: 'Biceps', exercises: 22, coverage: 80 },
  { muscle: 'Glutes', exercises: 30, coverage: 87 },
];

export const mockAdaptationData = [
  { adaptation: 'Hypertrophy', exercises: 89, coverage: 95 },
  { adaptation: 'Strength', exercises: 67, coverage: 92 },
  { adaptation: 'Endurance', exercises: 45, coverage: 78 },
  { adaptation: 'Power', exercises: 32, coverage: 65 },
  { adaptation: 'Flexibility', exercises: 28, coverage: 58 },
  { adaptation: 'Balance', exercises: 15, coverage: 42 },
];

export const mockGapsData = {
  underRepresentedMuscleGroups: [
    { name: 'Calves', exercises: 12, status: 'warning' as const },
    { name: 'Forearms', exercises: 8, status: 'warning' as const },
    { name: 'Tibialis Anterior', exercises: 3, status: 'danger' as const },
  ],
  missingEquipmentCategories: [
    { name: 'Suspension Trainers', status: 'danger' as const },
    { name: 'Balance Equipment', status: 'danger' as const },
  ],
  adaptationGaps: [
    { name: 'Coordination', coverage: 42, status: 'warning' as const },
    { name: 'Balance', coverage: 38, status: 'warning' as const },
  ],
}; 